import React from 'react';

function Error() {
    return (
        <div className="section secttion-center text-center">
            <h2>There was an error</h2>
        </div>
    );
}

export default Error;
